import React, { useState, useEffect } from 'react';
import TaskPopup from './taskPopup';
import { apiFetch } from './api';

const MeineTasks = ({ user }) => {
  const [tasks, setTasks] = useState([]);
  const [loading, setLoading] = useState(true);
  const [offeneTask, setOffeneTask] = useState(null);
  const [filter, setFilter] = useState('alle');

  const lade = async () => {
    const res = await apiFetch(`/meine/tasks?user_id=${user.id}`);
    const data = await res.json();
    setTasks(data);
    setLoading(false);
  };

  useEffect(() => { lade(); }, []);

  const heute0 = () => { const d = new Date(); d.setHours(0, 0, 0, 0); return d; };
  const wochenEnde = () => {
    const d = heute0();
    const ti = d.getDay();
    d.setDate(d.getDate() + (ti === 0 ? 0 : 7 - ti));
    d.setHours(23, 59, 59, 999);
    return d;
  };

  const parseDeadline = (dl) => {
    if (!dl) return null;
    const d = new Date(dl);
    d.setHours(0, 0, 0, 0);
    return d;
  };

  const istErledigt = (t) => t.status === 'erledigt';

  const gruppen = { heute: [], woche: [], spaeter: [], ohne: [] };
  const archiv = [];

  tasks.forEach(t => {
    if (istErledigt(t)) { archiv.push(t); return; }
    const dl = parseDeadline(t.deadline);
    if (!dl) { gruppen.ohne.push(t); return; }
    const h = heute0();
    const we = wochenEnde();
    if (dl.getTime() === h.getTime()) gruppen.heute.push(t);
    else if (dl < h) gruppen.heute.push(t);
    else if (dl <= we) gruppen.woche.push(t);
    else gruppen.spaeter.push(t);
  });

  const statusFarbe = (status) => {
    const f = { offen: '#9b9b9b', 'in arbeit': '#1565c0', erledigt: '#2e7d32' };
    return f[status] || '#9b9b9b';
  };

  const badge = (prio) => {
    const farben = {
      hoch: { bg: '#FCEBEB', text: '#A32D2D' },
      mittel: { bg: '#FAEEDA', text: '#854F0B' },
      niedrig: { bg: '#EAF3DE', text: '#3B6D11' }
    };
    const f = farben[prio] || farben.mittel;
    return (
      <span style={{ fontSize: '10px', padding: '2px 8px', borderRadius: '20px', backgroundColor: f.bg, color: f.text, textTransform: 'capitalize' }}>
        {prio}
      </span>
    );
  };

  const formatDeadline = (dl) => {
    if (!dl) return '—';
    const d = new Date(dl);
    const h = heute0();
    if (d.setHours(0,0,0,0) === h.getTime()) return 'Heute';
    const tage = ['So', 'Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa'];
    const dd = new Date(dl);
    return `${tage[dd.getDay()]} ${dd.getDate()}.${dd.getMonth() + 1}.`;
  };

  const taskZeile = (t) => (
    <div key={t.id} onClick={() => setOffeneTask(t.id)} style={{
      display: 'flex', alignItems: 'center', gap: '10px', padding: '10px 0', paddingLeft: '10px',
      borderBottom: '1px solid #f4f4f4', cursor: 'pointer',
      borderLeft: t.mutter_farbe ? `3px solid ${t.mutter_farbe}` : '3px solid transparent',
    }}>
      <span style={{ width: '7px', height: '7px', borderRadius: '50%', backgroundColor: statusFarbe(t.status), flexShrink: 0 }} />
      <span style={{ fontSize: '14px', color: '#1a1a1a', flex: 1, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{t.name}</span>
      <span style={{ fontSize: '12px', color: '#c4c4c4', flexShrink: 0 }}>{t.mutter_name} · {t.projekt_name}</span>
      {badge(t.prioritaet)}
      <span style={{ fontSize: '12px', color: '#9b9b9b', minWidth: '60px', textAlign: 'right', flexShrink: 0 }}>{formatDeadline(t.deadline)}</span>
    </div>
  );

  const sektion = (label, liste) => {
    if (liste.length === 0) return null;
    return (
      <div style={{ marginBottom: '28px' }}>
        <p style={{ fontSize: '11px', fontWeight: '500', color: '#9b9b9b', textTransform: 'uppercase', letterSpacing: '0.5px', marginBottom: '8px' }}>
          {label}
        </p>
        <div>{liste.map(taskZeile)}</div>
      </div>
    );
  };

  const filterBtn = (key, label) => (
    <span onClick={() => setFilter(key)} style={{
      fontSize: '12px', padding: '5px 12px', borderRadius: '20px', cursor: 'pointer',
      border: '1px solid ' + (filter === key ? '#1a1a1a' : '#e8e8e8'),
      backgroundColor: filter === key ? '#1a1a1a' : 'transparent',
      color: filter === key ? '#fff' : '#6b6b6b', fontWeight: filter === key ? '500' : '400'
    }}>{label}</span>
  );

  if (loading) return <div style={{ padding: '40px', color: '#9b9b9b', fontSize: '14px' }}>Lädt...</div>;

  const aktiveAnzahl = tasks.filter(t => !istErledigt(t)).length;

  return (
    <div style={{ padding: '40px' }}>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '28px' }}>
        <div>
          <h2 style={{ fontSize: '24px', fontWeight: '700', color: '#1a1a1a', margin: '0 0 6px 0', letterSpacing: '-0.5px' }}>Meine Tasks</h2>
          <p style={{ fontSize: '14px', color: '#9b9b9b', margin: 0 }}>
            {aktiveAnzahl} {aktiveAnzahl === 1 ? 'offene Task' : 'offene Tasks'}
          </p>
        </div>
        <div style={{ display: 'flex', gap: '6px' }}>
          {filterBtn('alle', 'Alle')}
          {filterBtn('heute', 'Heute')}
          {filterBtn('woche', 'Diese Woche')}
          {filterBtn('archiv', 'Archiv')}
        </div>
      </div>

      {filter === 'archiv' ? (
        archiv.length === 0 ? <p style={{ fontSize: '14px', color: '#c4c4c4' }}>Noch nichts im Archiv.</p> : sektion('Erledigt', archiv)
      ) : filter === 'heute' ? (
        gruppen.heute.length === 0 ? <p style={{ fontSize: '14px', color: '#c4c4c4' }}>Heute nichts fällig. 🎉</p> : sektion('Heute fällig', gruppen.heute)
      ) : filter === 'woche' ? (
        (gruppen.heute.length + gruppen.woche.length === 0) ? (
          <p style={{ fontSize: '14px', color: '#c4c4c4' }}>Diese Woche nichts fällig.</p>
        ) : (
          <>
            {sektion('Heute fällig', gruppen.heute)}
            {sektion('Diese Woche', gruppen.woche)}
          </>
        )
      ) : (
        aktiveAnzahl === 0 ? <p style={{ fontSize: '14px', color: '#c4c4c4' }}>Keine offenen Tasks. 🎉</p> : (
          <>
            {sektion('Heute fällig', gruppen.heute)}
            {sektion('Diese Woche', gruppen.woche)}
            {sektion('Später', gruppen.spaeter)}
            {sektion('Ohne Deadline', gruppen.ohne)}
          </>
        )
      )}

      {offeneTask && (
        <TaskPopup taskId={offeneTask} onClose={() => { setOffeneTask(null); lade(); }} />
      )}
    </div>
  );
};

export default MeineTasks;